import { Feature } from '@/pinia/feature'
import { apartments } from './apartments'
import { area } from './area'
import { premises } from './premises'

export const portfolioAnalysis: Feature = {
  name: 'portfolio',
  enabled: true,
  component: 'DashboardFeature',
  access: ['FEAT_PORTFOLIO-ANALYSIS_READER'],
  title: {
    en: 'Portfolio analysis',
    sv: 'Bestånds&shy;analys'
  },
  isRoute: true,
  props: {
    icon: 'IconGlobe2',
    showCalendar: false
  },
  children: [
    {
      name: 'filters',
      enabled: true,
      title: {
        en: 'Filters',
        sv: 'Filter'
      },
      component: 'PortfolioAnalysisFilters'
    },
    {
      name: 'data',
      enabled: true,
      title: {
        en: 'Data',
        sv: 'Data'
      },
      children: [area, premises, apartments]
    }
  ]
}
